import { data } from '../../svg/Contract/data';
import { makeIcon } from '../makeIcon';

export const Contract = makeIcon(data, 'contract', 'Contract');

export default Contract;
